import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ListReplicateInformationComponent } from './list-replicate-information.component';
import { PosTableModule } from 'src/app/shared/pos-table/pos-table.module';



@NgModule({
  declarations: [
    ListReplicateInformationComponent
  ],
  imports: [
    CommonModule,
    PosTableModule
  ],

  exports: [ListReplicateInformationComponent]
})
export class ListReplicateInformationModule { }
